import lazyPage from '@monorepo/deprecated/core/hoc/lazyPage'

export default () => [
  {
    component: lazyPage(() =>
      import('App/View/Errors').then(({ Error404 }) => Error404)
    ),
  },
]
